import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import { Button } from '@hydrodigital/design-system';

interface propertyTypes {
  selectedTransition: any;
  source: any;
  target: any;
  onCancel: Function;
  saveChanges: Function;
  deleteTransition: Function;
}

export default function TransitionModal({
  selectedTransition,
  source,
  target,
  onCancel,
  saveChanges,
  deleteTransition,
}: propertyTypes) {
  const [statement, setStatement] = useState("");

  useEffect(() => {
    if (selectedTransition) {
      setStatement(selectedTransition.condition.statement);
    }
  }, [selectedTransition]);

  return (
    <Modal
      title=""
      open={true}
      footer={[]}
      onCancel={() => {
        onCancel();
      }}
    >
      <div className="flex column">
        <span>Origin State: {source.data.label}</span>
        <span>Target State: {target.data.label}</span>
        <AceEditor
          className="mt-1"
          mode="python"
          theme="github"
          name="editor"
          onChange={(val) => {
            setStatement(val);
          }}
          value={statement}
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          setOptions={{
            useWorker: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
          placeholder="Type your code here"
          style={{ maxHeight: "120px", width: "auto" }}
        />
        <div className="flex justify-center mt-2" style={{ gap: '8px' }}>
          <Button
            label="Save"
            variant="primary"
            showIcon={false}
            size="small"
            onClick={() => {
              saveChanges({
                fromId: source.id,
                toId: target.id,
                condition: { statement: statement },
              });
              onCancel();
            }}
          />
          <Button
            label="Cancel"
            variant="secondary"
            showIcon={false}
            size="small"
            onClick={() => {
              onCancel();
            }}
          />
          {selectedTransition && (
            <Button
              label="Delete"
              variant="secondary"
              showIcon={false}
              size="small"
              onClick={() => {
                deleteTransition({
                  fromId: source.id,
                  toId: target.id,
                });
                onCancel();
              }}
              style={{ backgroundColor: '#ef4444', color: 'white', borderColor: '#ef4444' }}
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
